module.exports = __webpack_public_path__ + "static/img/jiaobanrizhi2.26da1283.png";